import React from 'react';
import PropTypes from 'prop-types';
import Currency from 'components/Currency';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

const StyledParagraph = styled.p`
  del {
    display: block;
    font-size: 0.75em;
    margin-bottom: 0.25em;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.small}) {
    margin-top: 0.2em;
  }
`;

const TileWrapper = styled.div`
  ${ifProp(
    { soldOut: true, isSelected: false },
    css`
      color: #777;
    `
  )}
`;

function DayWithMinimumRate({
  isCheckoutDate,
  isCompable,
  isSelected,
  hasOffer,
  minimumRate,
  showPrizeCode,
  prizeCode,
  offer,
  rackRate,
  useRackRate,
  hasWebOffer,
  isHostBooking,
  hasAvailability,
  hasOverrideCode
}) {
  const showOffer =
    !useRackRate &&
    (isCompable || hasWebOffer || hasOverrideCode) &&
    (showPrizeCode || !isSelected);
  const hasOffers = hasOffer || hasWebOffer;

  const minRateContent = (
    <React.Fragment>
      FROM{' '}
      <StyledParagraph>
        {(rackRate || minimumRate) && (
          <React.Fragment>
            {!useRackRate && rackRate !== minimumRate && rackRate !== null && (
              <del>
                <Currency
                  value={rackRate}
                  minimumFractionDigits={0}
                  maximumFractionDigits={0}
                />
              </del>
            )}
            <Currency
              value={useRackRate ? rackRate : minimumRate}
              minimumFractionDigits={0}
              maximumFractionDigits={0}
            />
          </React.Fragment>
        )}
      </StyledParagraph>
    </React.Fragment>
  );

  const compContent = showOffer && (hasOffer || hasWebOffer) && (
    <React.Fragment>
      <del>
        <Currency
          value={rackRate}
          minimumFractionDigits={0}
          maximumFractionDigits={0}
        />
      </del>
      <br />
      <strong>COMP</strong>
      <br />
    </React.Fragment>
  );

  return (
    <TileWrapper
      className="tile-wrapper"
      soldOut={isHostBooking && !hasAvailability}
      isSelected={isSelected}
    >
      {isCheckoutDate ? (
        <React.Fragment>
          <p>&nbsp;</p>CHECKOUT
        </React.Fragment>
      ) : showOffer ? (
        <React.Fragment>
          {hasOffers ? compContent : minRateContent}
          {!hasOffers && prizeCode}
        </React.Fragment>
      ) : (
        minRateContent
      )}
    </TileWrapper>
  );
}

DayWithMinimumRate.propTypes = {
  isCheckoutDate: PropTypes.bool,
  isCompable: PropTypes.bool,
  offer: PropTypes.object,
  isSelected: PropTypes.bool,
  hasOffer: PropTypes.bool,
  minimumRate: PropTypes.number,
  showPrizeCode: PropTypes.bool,
  prizeCode: PropTypes.string,
  rackRate: PropTypes.number,
  useRackRate: PropTypes.bool,
  hasWebOffer: PropTypes.bool,
  isHostBooking: PropTypes.bool,
  hasAvailability: PropTypes.bool,
  hasOverrideCode: PropTypes.bool
};

export default DayWithMinimumRate;
